import { api } from './http';

export async function getDashboard() {
  const response = await api.get('/api/monitoring/dashboard');
  return response.data;
}

export async function getMetrics() {
  const response = await api.get('/api/monitoring/metrics');
  return response.data;
}

export async function getTicketsByStatus() {
  const response = await api.get('/api/monitoring/tickets/status');
  return response.data;
}

export async function getTicketsByCollaborateur() {
  const response = await api.get('/api/monitoring/tickets/collaborateurs');
  return response.data;
}

export async function getTicketsByClient() {
  const response = await api.get('/api/monitoring/tickets/clients');
  return response.data;
}

export async function getTicketsEvolution(days = 30) {
  const response = await api.get(`/api/monitoring/tickets/evolution?days=${days}`);
  return response.data;
}

export async function getOverdueTickets(days = 7) {
  const response = await api.get(`/api/monitoring/tickets/overdue?days=${days}`);
  return response.data;
}

export async function getMostActiveTickets(limit = 10) {
  const response = await api.get(`/api/monitoring/tickets/active?limit=${limit}`);
  return response.data;
}


export async function getAlerts() {
  const response = await api.get('/api/monitoring/alerts');
  return response.data;
}

